<template>
  <v-app id="inspire">
    <Header/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Клиенты</div>
                  <div class="breadcrumb">Клиенты</div>
                </div>
              </v-col>
              <v-col>
                <v-sheet
                    rounded="lg"
                >
                  <v-card-title
                      class="custom__card-title"
                  >
                    <div class="search_client">
                      <v-text-field
                          v-model="search"
                          dense
                          required
                          label="Поиск клиентов"
                          outlined
                          style="font-size: 12px;font-weight: normal;"
                          background-color="white"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon>mdi-magnify</v-icon>
                        </template>
                      </v-text-field>
                      <v-btn
                          v-if="userType === 'МенеджерОтделаПродаж'"
                          @click="dialogClient = true"
                          class="search-button"
                      >
                        Создать клиента
                      </v-btn>
                      <v-btn
                          v-else
                          @click="dialogCreateDeal = true"
                          class="search-button"
                      >
                        + Создать сделку
                      </v-btn>
                    </div>
                    <div class="filter_client">
                      <span class="desktopRegularParagraph"><span>Выводить по</span></span>
                      <v-btn-toggle
                          v-model="toggle_exclusive"
                          mandatory
                          background-color="#FFFFFF"
                          class="mx-4 rounded-lg"
                      >
                        <v-btn :value="10">
                          10
                        </v-btn>
                        <v-btn :value="20">
                          20
                        </v-btn>
                        <v-btn :value="30">
                          30
                        </v-btn>
                      </v-btn-toggle>
                      <v-btn
                          dark
                          class="filter-button"
                          :disabled="isLoading && isLoadingFilterList"
                          @click="dialogFilter = !dialogFilter"
                      >
                        <img
                            class="mr-1"
                            src="/playground_assets/mediumfilter.svg"
                        >
                        Фильтр
                      </v-btn>
                    </div>

                  </v-card-title>
                  <v-card-text
                      v-show="dialogFilter"
                  >
                    <v-form
                        ref="filterClientsForm"
                        @submit.prevent="filterClients"
                        v-model="valid"
                        :lazy-validation="true"
                    >
                      <v-container>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                          >
                            <label>Пол</label>
                            <v-select
                                @input="collectData"
                                class="rounded-lg"
                                v-model="filterForm.gender"
                                :items="genderTypes"
                                ref="selectedEl1"
                                item-value="type_id"
                                item-text="type_name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              v-if="listStatus"
                          >
                            <label>Статус</label>
                            <v-select
                                @input="collectData"
                                class="rounded-lg"
                                v-model="filterForm.status"
                                :items="listStatus.status"
                                ref="selectedEl2"
                                item-value="id"
                                item-text="name"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              v-if="specialist"
                          >
                            <label>Менеджер</label>
                            <v-select
                                @input="collectData"
                                class="rounded-lg"
                                v-model="filterForm.manager"
                                :items="specialist.specialist"
                                item-value="id"
                                item-text="name"
                                ref="selectedEl3"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              class="mt-3"
                          >
                            <label>Возраст от</label>
                            <v-text-field
                                class="rounded-lg"
                                v-model.number="filterForm.start_age"
                                type="number"
                                hide-spin-buttons
                                name="start_age"
                                :rules="startAgeRules"
                                placeholder="Возраст от"
                                dense
                                outlined
                                single-line
                                style="height: 30px;margin-top: 10px"
                            >
                              <template v-slot:append>
                                <v-btn-toggle style="margin-right: -12px" class="rounded-r-lg no-active__toggle">
                                  <v-btn @click="downStartAge"
                                         style="padding: 0 !important; min-width: 38px !important; margin-top: -7px;">
                                    <v-icon>mdi-chevron-down</v-icon>
                                  </v-btn>
                                  <v-btn @click="upStartAge"
                                         style="padding: 0 !important; min-width: 38px !important; margin-top: -7px;">
                                    <v-icon>mdi-chevron-up</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              class="mt-3"
                          >
                            <label>Возраст до</label>
                            <v-text-field
                                class="rounded-lg"
                                v-model.number="filterForm.end_age"
                                type="number"
                                hide-spin-buttons
                                name="end_age"
                                :rules="endAgeRules"
                                placeholder="Возраст до"
                                dense
                                outlined
                                style="height: 30px;margin-top: 10px"
                            >
                              <template v-slot:append>
                                <v-btn-toggle style="margin-right: -12px" class="rounded-r-lg no-active__toggle">
                                  <v-btn @click="downEndAge"
                                         style="padding: 0 !important; min-width: 38px !important; margin-top: -7px;">
                                    <v-icon>mdi-chevron-down</v-icon>
                                  </v-btn>
                                  <v-btn @click="upEndAge"
                                         style="padding: 0 !important; min-width: 38px !important; margin-top: -7px;">
                                    <v-icon>mdi-chevron-up</v-icon>
                                  </v-btn>
                                </v-btn-toggle>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              class="mt-3"
                          >
                            <label>Дата регистрации</label>
                            <template>
                              <VueDatePicker
                                  no-title
                                  no-header
                                  color="#629f34"
                                  v-model="filterForm.date"
                                  range
                                  rangeInputText="%d - %d"
                                  format="DD MMMM"
                              >
                                <template #activator="{ date }">
                                  <button
                                      class="button custom__datepicker"
                                      ref="activator"
                                      type="button"
                                  >
                                    <div>
                                      <span v-if="date">{{ date }}</span>
                                      <span v-else style="color: gray">Дата регистрации</span>
                                    </div>
                                    <v-icon
                                        medium
                                        right
                                        class="ml-5"
                                    >
                                      mdi-calendar-blank-outline
                                    </v-icon>
                                  </button>
                                </template>
                              </VueDatePicker>
                            </template>
                          </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              v-if="listSources"
                          >
                            <label>Рекламный источник</label>
                            <v-select
                                @input="collectData"
                                class="rounded-lg"
                                v-model="filterForm.advertisiment"
                                :items="listSources.advertising ?? []"
                                item-value="id"
                                item-text="name"
                                ref="selectedEl3"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>

                          <v-col
                              cols="12"
                              sm="4"
                              md="4"
                              v-if="listTags"
                          >
                            <label>Тэг</label>
                            <v-select
                                @input="collectData"
                                class="rounded-lg"
                                v-model="filterForm.tag"
                                :items="listTags.tags ?? []"
                                item-value="id"
                                item-text="name"
                                ref="selectedEl3"
                                :menu-props="{ bottom: true, offsetY: true, rounded: 'lg' }"
                                label="Выбрать"
                                append-icon="mdi-chevron-down"
                                outlined
                                dense
                                style="height: 30px;margin-top: 10px"
                            ></v-select>
                          </v-col>

                          </v-row>
                        <v-row>
     
                          <v-card-actions class="mt-4">
                            <template v-if="!dialogButton">
                              <button
                                  class="button custom__button mt-5"
                                  type="button"
                                  @click="returnClients"
                              >
                                Применить
                              </button>
                            </template>
                            <template v-else>
                              <button
                                  class="button custom__button mt-5"
                                  type="submit"
                                  style="background-color: #A13453 !important;color: #fff !important;"
                              >
                                Применить
                              </button>
                              <button
                                  class="button custom__button mt-5 ml-3"
                                  type="button"
                                  style="background-color: #D53025 !important;color: #fff !important; width: auto !important; padding: 5px 20px;"
                                  @click="clearData"
                              >
                                Сбросить фильтр
                              </button>
                            </template>
                          </v-card-actions>
                        </v-row>
                      </v-container>
                    </v-form>
                  </v-card-text>
                  <v-skeleton-loader
                      v-if="isLoading"
                      type="table"
                  >
                  </v-skeleton-loader>
                  <v-data-table
                      v-else
                      :headers="headers"
                      :items="listClient.client"
                      :server-items-length="listClient.listLength"
                      no-data-text="Результатов не найдено"
                      :items-per-page="toggle_exclusive"
                      :hide-default-footer="true"
                      :page="page"
                      item-key="client_id"
                      class="elevation-1"
                  >
                    <template v-slot:item.name="{ item }">
                      <router-link
                          :to="{ name: 'CardClient', params: {client_id: item.client_id}}"
                          class="d-flex"
                          style="align-items: center; text-decoration: none; color: #000"
                      >
                        {{ item.name }}
                      </router-link>
                    </template>
                  </v-data-table>
                  <v-card-actions
                      class="d-flex justify-content-between"
                      style="padding: 20px !important;"
                  >
                    <template v-if="listClient">
                      <div>
                        <span class="desktopRegularLabel"><span>Показано с 1 по {{ toggle_exclusive }} из {{ listClient.listLength }} результатов</span></span>
                      </div>
                      <div>
                        <v-pagination
                            v-model="page"
                            circle
                            color="#629F33"
                            :length="listClient.paginationLength"
                            :total-visible="6"
                        ></v-pagination>
                      </div>
                    </template>
                  </v-card-actions>
                </v-sheet>

              </v-col>

            </v-row>
          </v-container>
        </v-row>

        <v-row justify="center">
          <v-dialog
              v-model="dialogClient"
              persistent
              max-width="700px"
          >
            <v-card rounded="lg">
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Новый клиент</h4>
                </div>
                <v-btn icon @click="dialogClient = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="addClientForm" @submit.prevent="submit">
                    <v-row>
                      <v-col
                          cols="12"
                          sm="6"
                          md="3"
                      >
                        <div class="user-avatar">
                          <img
                              v-if="!isCameraOpen"
                              src="/playground_assets/mediumcamera3282-238l.svg"
                              style="height: 37px; width: 46px"
                          />
                          <div v-show="isCameraOpen && isLoading2" class="camera-loading">
                            <ul class="loader-circle">
                              <li></li>
                              <li></li>
                              <li></li>
                            </ul>
                          </div>
                          <div v-if="isCameraOpen" v-show="!isLoading2" class="camera-box" :class="{ 'flash' : isShotPhoto }">
                            <div class="camera-shutter" :class="{'flash' : isShotPhoto}"></div>
                            <video v-show="!isPhotoTaken" style="border-radius:100%;" ref="camera" :width="210" :height="210" autoplay></video>
                            <canvas v-show="isPhotoTaken" style="border-radius:100%;" id="photoTaken" ref="canvas" :width="210" :height="210"></canvas>
                          </div>
                        </div>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="9"
                          style="display: flex; align-items: center; justify-content: start"
                      >
                        <div class="edit-button" >
                          <v-btn type="button" class="button__lighten-success" style="margin-top: 0 !important;" @click="toggleCamera">
                            <span v-if="!isCameraOpen">Изменить фото</span>
                            <span v-else>Закрыть камеру</span>
                          </v-btn>
                          <div v-if="isCameraOpen && !isLoading2 && !isPhotoTaken" class="camera-shoot" style="padding: 8px 20px !important;">
                            <button type="button" class="button" @click="takePhoto" style="width:40px; height:40px;">
                              <img src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png" style="width:30px; height:30px;">
                            </button>
                          </div>
                          <!-- <div v-if="isPhotoTaken && isCameraOpen" class="camera-download" style="width:100px;height:40px; padding-top:10px;">
                                    <a id="downloadPhoto" download="my-photo.jpg" class="button" role="button" @click="downloadImage">
                                      Сохранить
                                    </a>
                           </div> -->
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Фамилия</label>
                        <v-text-field
                            v-model="newClient.middle_name"
                            label="Фамилия"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Имя <span style="color: #D53025">*</span></label>
                        <v-text-field
                            v-model="newClient.first_name"
                            :rules="firstNameRules"
                            label="Имя"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Отчество</label>
                        <v-text-field
                            v-model="newClient.last_name"
                            label="Отчество"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-5">
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Телефон <span style="color: #D53025">*</span></label>
                        <v-text-field
                            v-model="newClient.phone"
                            :rules="phoneRules"
                            v-mask="'+7 (###) ###-##-###'"
                            label="Телефон"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Электронная почта</label>
                        <v-text-field
                            v-model="newClient.email"
                            :rules="emailRules"
                            label="Электронная почта"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                          sm="6"
                          md="4"
                      >
                        <label>Пол</label>
                        <v-select
                            v-model="newClient.gender"
                            :items="genderTypes"
                            item-value="type_id"
                            item-text="type_name"
                            label="Пол"
                            class="rounded-lg"
                            outlined
                            dense
                            style="height: 30px;margin-top: 10px"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-card-actions style="padding: 30px 10px !important;">
                        <button
                            class="button button__success"
                            ref="activator"
                            type="submit"
                            :disabled="isLoading"
                        >
                          Сохранить
                        </button>
                        <v-text-field
                            v-model="bracelet"
                            label="Браслет/карта"
                            @focusin="searchBracelet"
                            @focusout="stopCard"
                            class="rounded-lg ml-5"
                            hide-details
                            outlined
                            dense
                        ></v-text-field>
                      </v-card-actions>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog
              v-model="dialogCreateDeal"
              persistent
              max-width="500px"
          >
            <v-card>
              <v-card-title class="justify-space-between">
                <div></div>
                <div>
                  <h4>Новая сделка</h4>
                </div>
                <v-btn icon @click="dialogCreateDeal = false" >
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </v-card-title>
              <v-container style="padding: 60px">
                <template>
                  <button
                      class="button button__lighten"
                      style="width: 100% !important;"
                      @click="createDeal('Продажа')"
                  >
                    Продажа
                  </button>
                  <button
                      class="button button__lighten"
                      style="width: 100% !important; margin-top: 20px !important;"
                      @click="createDeal('Продление')"
                  >
                    Продление
                  </button>
                </template>
              </v-container>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {VueDatePicker} from '@mathieustan/vue-datepicker';
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import {getItem, setItem} from '@/helpers/persistanceStorage';
import {mapState} from "vuex";
import {clientActionTypes} from '@/store/modules/client';
import {lessonActionTypes} from '@/store/modules/lesson';
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {monitorActionTypes} from "@/store/modules/monitor";
import {advertisingActionTypes} from "@/store/modules/advertising";
import {tagsActionTypes} from '@/store/modules/tags';

export default {
  name: "Clients",
  components: {
    VueDatePicker,
    Header,
    Menu
  },
  data() {
    return {
      page: 1,
      valid: true,
      bracelet: '',
      basePhoto:null,
      counterInterval: null,
      isCameraOpen: false,
      isPhotoTaken: false,
      isShotPhoto: false,
      isLoading2: false,
      newClient: {
        first_name: '',
        middle_name: '',
        last_name: '',
        gender: '',
        email: '',
        phone: '',
      },
      filterForm: {
        gender: null,
        status: null,
        manager: null,
        start_age: null,
        end_age: null,
        date: null,
        advertisiment:null,
        tag:null
      },
      firstNameRules: [
        v => !!v || 'Имя обязательное поле'
      ],
      middleNameRules: [
        v => !!v || 'Фамилия обязательное поле'
      ],
      lastNameRules: [
        v => !!v || 'Отчество обязательное поле'
      ],
      genderRules: [
        v => !!v || 'Пол обязательное поле'
      ],
      genderTypes: [
        {type_id: 1, type_name: 'Мужской'},
        {type_id: 2, type_name: 'Женский'},
      ],
      emailRules:  [
        v => {
          if (v !== ''){
            return  /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена';
          }
          else return true;
        }
      ],
      phoneRules: [
        v => !!v || 'Телефон обязательное поле'
      ],
      statusTypes: [
        {type_id: 1,type_name: 'Потенциальный'},
        {type_id: 2,type_name: 'Член клуба'},
        {type_id: 3,type_name: 'Клиент клуба'},
        {type_id: 4,type_name: 'Бывший клиент клуба'},
        {type_id: 5,type_name: 'Отказ'}
      ],
      startAgeRules:  [
        v => {
          if (v >= 0 && v !== '' && v !== null) return /^\d+$/.test(v) && v >= 0 && v <= 150 || 'Введите число от 0 до 150';
          else return true;
        }
      ],
      endAgeRules:  [
        v => {
          if (v >= 0 && v !== '' && v !== null) return /^\d+$/.test(v) && v >= (this.start_age + 1) && v <= 150 || 'Введите число от ' + (this.start_age + 1) + ' до 150';
          else return true;
        }
      ],
      drawer: true,
      search: '',
      placeholder: 'Выбрать',
      toggle_exclusive: 10,
      dialogFilter: false,
      dialogClient: false,
      dialogCreateDeal: false,
      type: null,
      listDeals: [],
      dialogButton: false,
      select: null,
      selected: [],
      headers: [
        {
          text: 'Клиент',
          align: 'start',
          value: 'name'
        },
        /*        {
                  text: 'Карта',
                  value: 'card'
                },
                {
                  text: 'Статус',
                  value: 'status'
                },
                {
                  text: 'Абонемент',
                  value: 'subscribe'
                },
                {
                  text: 'Дата начала',
                  value: 'start_date'
                },
                {
                  text: 'Дата окончания',
                  value: 'end_date'
                },*/
        {
          text: 'Контакт',
          value: 'phone'
        },
        {
          text: 'Менеджер',
          value: 'manager.name'
        },
      ],
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      isLoadingFilterList: state => state.lesson.isLoading,
      listClient: state => state.client.listClient,
      listStatus: state => state.client.listStatus,
      specialist: state => state.lesson.specialist,
      validationErrors: state => state.client.validationErrors,
      userType: state => state.userType,
      listSources: state => state.advertising.listSources,
      listTags: state => state.tags.data
    })
  },
  methods: {
    stopCard(){
      clearInterval(this.counterInterval)
    },
    fetchFeedCard(card_id) {
      this.bracelet = card_id;
    },
    fetchFeed(limit) {
      let page = 1;
      this.$store.dispatch(clientActionTypes.getClientList, {
        page,
        limit,
        gender: this.filterForm.gender,
        manager_id: this.filterForm.manager,
        registration_date_from: (this.filterForm.date && this.filterForm.date.start) ? this.filterForm.date.start : this.filterForm.date,
        registration_date_before: (this.filterForm.date && this.filterForm.date.end) ? this.filterForm.date.end : this.filterForm.date,
        date_birth_from: this.filterForm.end_age,
        date_birth_before: this.filterForm.start_age,
        status: this.filterForm.status,
        advertisiment:this.filterForm.advertisiment,
          tag:this.filterForm.tag
      });
      this.$store.dispatch(lessonActionTypes.getSpecialistList);
      this.$store.dispatch(clientActionTypes.getStatusList);
    },
    toggleCamera() {
      if(this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },
    createCameraElement() {
      this.isLoading2 = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true
      });

      navigator.mediaDevices
          .getUserMedia(constraints)
          .then(stream => {
            this.isLoading2 = false;
            this.$refs.camera.srcObject = stream;
          })
          .catch(error => {
            this.isLoading2 = false;
            alert("May the browser didn't support or there is some errors.");
          });
    },
    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach(track => {
        track.stop();
      });
    },
    takePhoto() {
      if(!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;

      const context = this.$refs.canvas.getContext('2d');
      context.drawImage(this.$refs.camera, 0, 0, 210, 210);

      const getBase64StringFromDataURL = (dataURL) =>
          dataURL.replace('data:', '').replace(/^.+,/, '');

      this.basePhoto = getBase64StringFromDataURL(document.getElementById("photoTaken").toDataURL("image/jpeg"));

      console.log(this.basePhoto)

    },
    downloadImage() {
      const download = document.getElementById("downloadPhoto");
      const canvas = document.getElementById("photoTaken").toDataURL("image/jpeg")
          .replace("image/jpeg", "image/octet-stream");

      download.setAttribute("href", canvas);
    },
    submit() {
      if (this.$refs.addClientForm.validate()) {
        this.$store.dispatch(clientActionTypes.createClient, {
          from: 'reception',
          last_name: this.newClient.last_name,
          first_name: this.newClient.first_name,
          middle_name: this.newClient.middle_name,
          phone: this.newClient.phone,
          email: this.newClient.email,
          gender: this.newClient.gender,
          client_card: this.bracelet,
          photo: this.basePhoto
        })
            .then(() => {
              this.fetchFeed(this.toggle_exclusive);
              this.$refs.addClientForm.reset();
              this.dialogClient = false;
            })
      }
    },
    downStartAge() {
      if (this.filterForm.start_age === '' || this.filterForm.start_age === null) {
        this.filterForm.start_age = 0;
      } else {
        if (this.filterForm.start_age !== 0) {
          this.filterForm.start_age--;
        }
      }
    },
    upStartAge() {
      if (this.filterForm.start_age === '' || this.filterForm.start_age === null) {
        this.filterForm.start_age = 0;
      } else {
        if (this.filterForm.start_age !== 150) {
          this.filterForm.start_age++;
        }
      }
    },
    downEndAge() {
      if (this.filterForm.end_age === '' || this.filterForm.end_age === null) {
        this.filterForm.end_age = 0;
      } else {
        if (this.filterForm.end_age !== 0) {
          this.filterForm.end_age--;
        }
      }
    },
    upEndAge() {
      if (this.filterForm.end_age === '' || this.filterForm.end_age === null) {
        this.filterForm.end_age = 0;
      } else {
        if (this.filterForm.end_age !== 150) {
          this.filterForm.end_age++;
        }
      }
    },
    filterClients() {
      console.log(this.filterForm)

      if (this.filterForm.start_age !== null || this.filterForm.start_age !== '') {
        if (!this.$refs.filterClientsForm.validate('start_age')) {
          this.valid = false;
        }
      }
      if (this.filterForm.end_age !== null || this.filterForm.end_age !== '') {
        if (!this.$refs.filterClientsForm.validate('end_age')) {
          this.valid = false;
        }
      }
      if (this.valid) {
        this.$store.dispatch(clientActionTypes.getClientList, {
          page: 1,
          limit: 10,
          gender: this.filterForm.gender,
          manager_id: this.filterForm.manager,
          registration_date_from: (this.filterForm.date && this.filterForm.date.start) ? this.filterForm.date.start : this.filterForm.date,
          registration_date_before: (this.filterForm.date && this.filterForm.date.end) ? this.filterForm.date.end : this.filterForm.date,
          date_birth_from: this.filterForm.end_age,
          date_birth_before: this.filterForm.start_age,
          status: this.filterForm.status,
          advertisiment:this.filterForm.advertisiment,
          tag:this.filterForm.tag
        })
      }
    },
    returnClients() {
      if (!this.dialogButton) {
        this.fetchFeed(this.toggle_exclusive);
      }
    },
    collectData(selected) {
      this.selected.push(selected)
      if (this.selected !== [] || this.filterForm.start_age !== null || this.filterForm.end_age !== null) {
        this.dialogButton = true;
      }
    },
    clearData() {
      this.$refs.filterClientsForm.reset();
      this.selected.length = 0;
      this.filterForm.gender = null;
      this.filterForm.start_age = null;
      this.filterForm.end_age = null;
      this.filterForm.manager = null;
      this.filterForm.date = null;
      this.filterForm.status = null;
      this.dialogButton = false;

      let limit = this.toggle_exclusive
      //this.filterForm.date = new Date();

      let page = 1;
      this.$store.dispatch(clientActionTypes.getClientList, {
        page,
        limit,
        gender: this.filterForm.gender,
        manager_id: this.filterForm.manager,
        registration_date_from: null,
        registration_date_before: null,
        date_birth_from: this.filterForm.end_age,
        date_birth_before: this.filterForm.start_age,
        status: this.filterForm.status,
        advertisiment:this.filterForm.advertisiment,
        tag:this.filterForm.tag
      });
    },
    sendRequest() {
      this.cardRightNow = false;
      var xmlhttp = new XMLHttpRequest();
      let vm = this

      xmlhttp.onreadystatechange = function() {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) { // XMLHttpRequest.DONE == 4
          console.log('RESSS'+xmlhttp.responseText)
          //let responseTest = '3FB5DF5B ';
          if (xmlhttp.status == 200) {
            clearInterval(vm.counterInterval)
            if(xmlhttp.responseText.length>0)
            {
              if(!vm.cardRightNow)
              {
                var transformArray = xmlhttp.responseText.split(/(..)/g).filter(s => s);
                transformArray.reverse();
                var resultString = transformArray.length === 7 ? transformArray.join('') : transformArray.join('')+'000000';
                console.log(resultString);
                console.log('Card has been placed on reader: '+resultString); // action here!!!!

                //vm.$router.push({ name: 'Desktop', params: { client_id: resultString } })
                vm.fetchFeedCard(resultString);
                vm.cardRightNow = true;
              }
            }
            else
            {
              vm.counterInterval = setInterval(vm.sendRequest, 1000);
              if(vm.cardRightNow)
              {
                cardRightNow = false;
                console.log('no card');
                console.log('Card has been removed from reader: '); //card removed (may be needed in future)
              }
            }
          }
          else if (xmlhttp.status == 400) {
            console.log('There was an error 400');
          }
          else {
            console.log('something else other than 200 was returned');
          }

        }
      };

      xmlhttp.open("GET", "http://localhost:8081/scard", true);
      xmlhttp.send();
    },
    searchBracelet() {
      this.counterInterval = setInterval(this.sendRequest, 1000);
    },
    createDeal(type) {
      this.$store.dispatch(monitorActionTypes.getListDeal, {
        type
      })
          .then((response) => {
            if (response.monitor.length === 1) {
              this.$router.push({ name: 'CreateClient', params: { deal: response.monitor[0] } })
            }
          });
    }
  },
  destroyed: function(){
    clearInterval(this.counterInterval)
  },
  mounted() {
    setItem('schedule-service', null)
    setItem('schedule-client_id', null)
    setItem('schedule-client_name', null)
    setItem('schedule-search_client', null)
    setItem('schedule-select_client', null)
    setItem('sales-monitor-specialist_id', null);
    setItem('sales-monitor-specialist_type', null);
    setItem('sales-monitor-datetype', null);
    setItem('sales-monitor-datetype_date', null);

    setItem('report_12',null);
    setItem('report_13',null);
    setItem('report_14',null);
    setItem('report_15',null);
    setItem('report_16',null);
    setItem('report_17',null);
    
    setItem('report_newclient_id',null);
    
    if (JSON.parse(getItem('filter-gender')))
      this.filterForm.gender = JSON.parse(getItem('filter-gender'));
    if (JSON.parse(getItem('filter-manager')))
      this.filterForm.manager = JSON.parse(getItem('filter-manager'));
    if (JSON.parse(getItem('filter-status')))
      this.filterForm.status = JSON.parse(getItem('filter-status'));
    if (JSON.parse(getItem('filter-start_age')))
      this.filterForm.start_age = JSON.parse(getItem('filter-start_age'));
    if (JSON.parse(getItem('filter-end_age')))
      this.filterForm.end_age = JSON.parse(getItem('filter-end_age'));
    if (JSON.parse(getItem('filter-date')))
      this.filterForm.date = JSON.parse(getItem('filter-date'));
    this.fetchFeed(this.toggle_exclusive);
    this.$store.dispatch(advertisingActionTypes.getSources)
    this.$store.dispatch(tagsActionTypes.tagsList)
  },
  watch: {
    toggle_exclusive() {
      this.page = 1;
      if (this.search === '') {
        let page = this.page;
        let limit = this.toggle_exclusive;
        this.$store.dispatch(clientActionTypes.getClientList, {
          page,
          limit,
          gender: this.filterForm.gender,
          manager_id: this.filterForm.manager,
          registration_date_from: (this.filterForm.date && this.filterForm.date.start) ? this.filterForm.date.start : this.filterForm.date,
          registration_date_before: (this.filterForm.date && this.filterForm.date.end) ? this.filterForm.date.end : this.filterForm.date,
          date_birth_from: this.filterForm.end_age,
          date_birth_before: this.filterForm.start_age,
          status: this.filterForm.status,
          advertisiment:this.filterForm.advertisiment,
          tag:this.filterForm.tag
        })
      }
    },
    page() {
      if (this.search === '') {
        let page = this.page;
        let limit = this.toggle_exclusive;
        this.$store.dispatch(clientActionTypes.getClientList, {
          page,
          limit,
          gender: this.filterForm.gender,
          manager_id: this.filterForm.manager,
          registration_date_from: (this.filterForm.date && this.filterForm.date.start) ? this.filterForm.date.start : this.filterForm.date,
        registration_date_before: (this.filterForm.date && this.filterForm.date.end) ? this.filterForm.date.end : this.filterForm.date,
          date_birth_from: this.filterForm.end_age,
          date_birth_before: this.filterForm.start_age,
          status: this.filterForm.status,
          advertisiment:this.filterForm.advertisiment,
          tag:this.filterForm.tag
        })
      }
    },
    search() {
      if (this.search !== '') {
        this.$store.dispatch(clientActionTypes.searchClient, {
          client_field: this.search
        })
      } else {
        this.fetchFeed(this.toggle_exclusive);
      }
    },
    'filterForm.gender'() {
      if (this.filterForm.gender !== null) {
        setItem('filter-gender',JSON.stringify(this.filterForm.gender));
        this.dialogButton = true;
      }
    },
    'filterForm.manager'() {
      if (this.filterForm.manager !== null) {
        setItem('filter-manager',JSON.stringify(this.filterForm.manager));
        this.dialogButton = true;
      }
    },
    'filterForm.status'() {
      if (this.filterForm.status !== null) {
        setItem('filter-status',JSON.stringify(this.filterForm.status));
      }
    },
    'filterForm.start_age'() {
      if (this.filterForm.start_age !== null) {
        setItem('filter-start_age',JSON.stringify(this.filterForm.start_age));
        this.dialogButton = true;
      }
    },
    'filterForm.end_age'() {
      if (this.filterForm.end_age !== null) {
        setItem('filter-end_age',JSON.stringify(this.filterForm.end_age));
        this.dialogButton = true;
      }
    },
    'filterForm.date'() {
      if (this.filterForm.date !== null) {
        setItem('filter-date',JSON.stringify(this.filterForm.date));
        this.dialogButton = true;
      }
    }
  }
}
</script>

<style scoped>
.vd-activator .custom__datepicker {
  width: 87% !important;
  height: 14px !important;
  display: flex !important;
  padding: 12px 16px !important;
  position: relative !important;
  box-sizing: content-box !important;
  align-items: center !important;
  flex-shrink: 0 !important;
  border-color: #E0E0E0 !important;
  border-style: solid !important;
  border-width: 1px !important;
  border-radius: 8px !important;
  justify-content: center !important;
  margin-top: 9px !important;
  background-color: #ffffff !important;
  font-size: 14px !important;
  color: #000 !important;
}

@media (min-width: 1904px) {
  .vd-activator .custom__datepicker {
    width: 91% !important;
  }
}

@media (min-width: 1264px) and (max-width: 1390px) {
  .vd-activator .custom__datepicker {
    width: 85% !important;
  }
}

.custom__card-title {
  justify-content: space-between;
  flex-wrap: wrap;
}

.search_client {
  min-width: 50%;
  display: flex;
  align-items: center;
}

.filter_client {
  min-width: 40%;
  margin-top: -27px;
}

@media (max-width: 1264px) {
  .filter_client {
    margin-top: 0;
    margin-bottom: 20px;
  }
}

.custom__button {
  width: 121px !important;
  height: 38px;
  display: flex;
  gap: 4px;
  padding: 5px 10px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  border-radius: 12px !important;
  margin-top: 0 !important;
  justify-content: center;
  background-color: #F1F1F1 !important;
  font-size: 16px;
  font-weight: 700;
  color: #1A1A1A !important;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 36px !important;
  color: #767676 !important;
}

.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: white !important;
  border-bottom: none !important;
}

.v-text-field--outlined >>> fieldset {
  border-color: #E0E0E0;
  font-size: 11px;
}

.v-card__subtitle, .v-card__text, .v-card__title {
  padding-bottom: 0 !important;
}

.edit-button {
  width: 100%;
  display: flex;
  align-items: center;
}

.user-avatar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  width: 100px;
  height: 100px;
  border-radius: 145px;
  background-color: #F1F1F1;
}


.web-camera-container {
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 500px;
}
.web-camera-container .camera-button {
  margin-bottom: 2rem;
}
.web-camera-container .camera-box .camera-shutter {
  opacity: 0;
  width: 450px;
  height: 337.5px;
  background-color: #fff;
  position: absolute;
}
.web-camera-container .camera-box .camera-shutter.flash {
  opacity: 1;
}
.web-camera-container .camera-shoot {
  margin: 1rem 0;
}
.web-camera-container .camera-shoot button {
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}
.web-camera-container .camera-shoot button img {
  height: 15px;
  object-fit: cover;
}
.web-camera-container .camera-loading {
  overflow: hidden;
  height: 100%;
  position: absolute;
  width: 100%;
  min-height: 150px;
  margin: 3rem 0 0 -1.2rem;
}
.web-camera-container .camera-loading ul {
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 999999;
  margin: 0;
}
.web-camera-container .camera-loading .loader-circle {
  display: block;
  height: 14px;
  margin: 0 auto;
  top: 50%;
  left: 100%;
  transform: translateY(-50%);
  transform: translateX(-50%);
  position: absolute;
  width: 100%;
  padding: 0;
}
.web-camera-container .camera-loading .loader-circle li {
  display: block;
  float: left;
  width: 10px;
  height: 10px;
  line-height: 10px;
  padding: 0;
  position: relative;
  margin: 0 0 0 4px;
  background: #999;
  animation: preload 1s infinite;
  top: -50%;
  border-radius: 100%;
}
.web-camera-container .camera-loading .loader-circle li:nth-child(2) {
  animation-delay: 0.2s;
}
.web-camera-container .camera-loading .loader-circle li:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes preload {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
  100% {
    opacity: 1;
  }
}

</style>